<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">Modifica Mailing list</div>
</div>

<!-- Modal body -->
<div class="modal-body pb-6">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_email" class="form-label label-fw">Nome*</label>
                    <input formControlName="email" name="email" type="text"
                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                        class="form-control form-fw " id="field_email" placeholder="Nome">
                    <div class="invalid-feedback" *ngIf="formControls.email.touched">
                        <span *ngIf="formControls.email.errors && formControls.email.errors?.required">
                            email is required
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3 mt-2">
                    <angular2-multiselect [settings]="typeSettings" [data]="typeList" [(ngModel)]="selectedType"
                        [ngModelOptions]="{standalone: true}">
                    </angular2-multiselect>
                </div>
            </div>
        </div>
    </form>
</div>
  <!-- Modal footer -->
  <div class="modal-foot">
    <div class="row my-3 text-center">
        <button type="button"
            [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false || selectedType.length == 0 "
            class="btn btn-fw text me-3" (click)="clickButtonSave()">Crea</button>
        <button type="button" class="btn btn-outline-fw text"
            (click)="clickButtonCancel()">Annulla</button>
    </div>
</div>